module.exports = __webpack_public_path__ + "img/building-small.3710295a.png";